import { render, staticRenderFns } from "./basketItemsList.vue?vue&type=template&id=58be754e"
import script from "./basketItemsList.vue?vue&type=script&lang=js"
export * from "./basketItemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports